import { IS_LOADING, ERROR } from "../../constants";

export { IS_LOADING, ERROR };

export const GET_ABSENCES = "GET_ABSENCES";
export const GET_ABSENCES_ACTIVITY_TYPES = "GET_ABSENCES_ACTIVITY_TYPES";
export const SWITCH_ABSENCES_MODE = "SWITCH_ABSENCES_MODE";
export const SET_STATUS_FILTER = "SET_STATUS_FILTER";
export const SET_ABSENCE_DETAILS = "SET_ABSENCE_DETAILS";
export const SET_ABSENCE_CREATION_FIELDS = "SET_ABSENCE_CREATION_FIELDS";
export const SET_REDIRECT_URL = "SET_REDIRECT_URL";
export const SET_EDITION_STATE = "SET_EDITION_STATE";
export const GET_REFUSE_REASONS = "GET_REFUSE_REASONS";
